import { frontendURL } from '../../../helper/URLHelper';
import KanbanIndex from './Index.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    component: KanbanIndex,
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    },
    children: [
      {
        path: '',
        name: 'kanban_view',
        component: KanbanIndex,
        meta: {
          featureFlag: FEATURE_FLAGS.CRM,
          permissions: ['administrator', 'agent', 'contact_manage'],
        },
      },
    ],
  },
];
